import { render } from "./ViewInscriptionPage.vue?vue&type=template&id=6f8ebc11&ts=true"
import script from "./ViewInscriptionPage.vue?vue&type=script&lang=ts"
export * from "./ViewInscriptionPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__